/* -disable react/forbid-prop-types */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { TransitionGroup } from 'react-transition-group';
import { connect } from 'react-redux';

import LoadMask from '../../../../components/LoadMask';
import { rolesList } from '../../../../redux/auth';
import { getPlatformUsersUI } from '../../../../redux/selectors';

import logo from '../../../../assets/images/luft-digital-white@2x.png';
import { APP_VERSION } from '../../../../utils/constants';

import {
  CompanyAndUserInfo,
  CompanyNameStyled,
  CSSTransitionStyles,
  SidebarActiveCompany,
  SidebarActiveCompanyIcon,
  SidebarAppVersion,
  SidebarBackdrop,
  SidebarHeader,
  SidebarHr,
  SidebarLogo,
  SidebarNav,
  SidebarNavItem,
  SidebarNavLink,
  SidebarNavLinkIcon,
  SidebarNavLinkRouter,
  SidebarNavList,
  SidebarPanel,
} from './styles';
import { LOCAL_STORAGE_USER_NAME } from '../../../../shared/http/auth';

// Utils

const _hasRole = (role, userRoles) => userRoles.indexOf(role) !== -1;

// Component

const Sidebar = ({
  isVisible,
  onBackdropClick,
  onLogout,
  onChangePassword,
  activeCompany,
  onCompanySelect,
  roles,
  onIntegrationTokenRequest,
  integrationTokenIsFetching,
  onNavigate,
}) => {
  useEffect(() => {
    document.body.style.overflow = 'visible';
  }, []);

  document.body.style.overflow = isVisible ? 'hidden' : 'visible';

  const isAdmin = _hasRole(rolesList.ADMINISTRATOR, roles);

  const getUserName = window.localStorage.getItem(LOCAL_STORAGE_USER_NAME);

  const token = window.localStorage.getItem('Luft/SessionToken');

  const email = window.localStorage.getItem('Luft/UserEmail');

  const schedulingURL = `https://agendamento.luft.com.br/logindirect/${email}/${token}`;

  const _renderMenuItem = (path, text) => (
    <SidebarNavItem>
      <SidebarNavLinkRouter
        activeClassName="Sidebar__nav-link--active"
        to={path}
        onClick={() => {
          onNavigate(path);
        }}
      >
        {text}
      </SidebarNavLinkRouter>
    </SidebarNavItem>
  );

  const _renderSchedulingMenuItem = (path, text) => (
    <SidebarNavItem>
      <SidebarNavLink
        activeClassName="Sidebar__nav-link--active"
        to={path}
        onClick={() => {
          window.open(schedulingURL, '_blank', 'noopener,noreferrer');
        }}
      >
        {text}
      </SidebarNavLink>
    </SidebarNavItem>
  );

  const _renderMenuList = () => (
    <SidebarNavList>
      {(isAdmin ||
        _hasRole(rolesList.DASHBOARD, roles) ||
        _hasRole(rolesList.NUFARM, roles)) &&
        _renderMenuItem('/u/dashboard', 'Dashboard')}
      {(isAdmin ||
        _hasRole(rolesList.TRAVEL_MONITORING, roles) ||
        _hasRole(rolesList.NUFARM, roles)) &&
        _renderMenuItem('/u/travel-monitoring', 'Acompanhamento de viagens')}
      {(isAdmin ||
        _hasRole(rolesList.VEHICLES, roles) ||
        _hasRole(rolesList.NUFARM, roles)) &&
        _renderMenuItem('/u/vehicles', 'Veículos')}
      {(isAdmin ||
        _hasRole(rolesList.MANIFESTS_IN_TRANSIT, roles) ||
        _hasRole(rolesList.NUFARM, roles)) &&
        _renderMenuItem('/u/manifests-in-transit', 'Manifestos em trânsito')}
      {(isAdmin || _hasRole(rolesList.TRACKING, roles)) &&
        _renderMenuItem('/u/tracking', 'Tracking Integrado')}
      {(isAdmin || _hasRole(rolesList.RECIPIENT_TRACKING, roles)) &&
        _renderMenuItem('/u/recipient-tracking', 'Tracking Destinatário')}
      {(isAdmin || _hasRole(rolesList.ADMIN_CUSTOMER, roles)) &&
        _renderMenuItem('/u/admin', 'Admin')}
      {(isAdmin || _hasRole(rolesList.STOCK, roles)) &&
        _renderMenuItem('/u/estoque', 'Estoque')}
      {(isAdmin || _hasRole(rolesList.SCHEDULING, roles)) &&
        _renderSchedulingMenuItem('/u/agendamento', 'Agendamento')}
      {(isAdmin || _hasRole(rolesList.ADMIN_CUSTOMER, roles)) &&
        _renderMenuItem(
          '/u/dashboard-operacional/deposito',
          'Dashboard Operacional',
        )}

      {/* ARMAZÉM GERAL - Redirect auth link */}
      {(isAdmin || _hasRole(rolesList.GENERAL_WAREHOUSE, roles)) && (
        <SidebarNavItem>
          <SidebarNavLink onClick={onIntegrationTokenRequest}>
            Armazém Geral
            {integrationTokenIsFetching && <LoadMask text="Carregando..." />}
          </SidebarNavLink>
        </SidebarNavItem>
      )}
      {(isAdmin || _hasRole(rolesList.ADMINISTRATOR, roles)) &&
        _renderMenuItem('/u/comprovantes', 'Comprovantes')}
      {(isAdmin || _hasRole(rolesList.DASHBOARD_DISCHARGES, roles)) &&
        _renderMenuItem('/u/baixas', 'Baixas do App')}
      {(isAdmin || _hasRole(rolesList.CARBON_EMISSIONS, roles)) &&
        _renderMenuItem('/u/emissoes-co2', 'Emissões de CO2')}
      {_hasRole(rolesList.NOTES_CONNECTION, roles) &&
        _renderMenuItem('/u/conexao-notas', 'Conexão de notas')}
    </SidebarNavList>
  );

  return (
    <TransitionGroup>
      {isVisible && (
        <CSSTransitionStyles appear classNames="Sidebar" timeout={200}>
          <SidebarBackdrop
            className="Sidebar__backdrop"
            onClick={onBackdropClick}
          >
            <SidebarPanel
              className="Sidebar__panel"
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <SidebarHeader>
                <SidebarLogo src={logo} alt="" />
              </SidebarHeader>

              <SidebarActiveCompany
                isAdmin={isAdmin}
                onClick={isAdmin ? onCompanySelect : undefined}
              >
                <SidebarActiveCompanyIcon />
                <CompanyAndUserInfo>
                  <span>{getUserName || null}</span>
                  <CompanyNameStyled>
                    {activeCompany ? activeCompany.name : null}
                  </CompanyNameStyled>
                </CompanyAndUserInfo>
              </SidebarActiveCompany>

              <SidebarNav>
                {_renderMenuList()}
                <SidebarHr />
                <SidebarNavList>
                  <SidebarNavItem>
                    <SidebarNavLink onClick={onChangePassword}>
                      <SidebarNavLinkIcon name="lock" />
                      Alterar senha
                    </SidebarNavLink>
                  </SidebarNavItem>
                  <SidebarNavItem>
                    <SidebarNavLink onClick={onLogout}>
                      <SidebarNavLinkIcon name="exit" />
                      Sair
                    </SidebarNavLink>
                  </SidebarNavItem>
                </SidebarNavList>
              </SidebarNav>

              <SidebarAppVersion>Versão {APP_VERSION}</SidebarAppVersion>
            </SidebarPanel>
          </SidebarBackdrop>
        </CSSTransitionStyles>
      )}
    </TransitionGroup>
  );
};

Sidebar.propTypes = {
  isVisible: PropTypes.bool,
  onBackdropClick: PropTypes.func,
  onLogout: PropTypes.func,
  onChangePassword: PropTypes.func,
  onNavigate: PropTypes.func,
  roles: PropTypes.array,
  onIntegrationTokenRequest: PropTypes.func,
};

Sidebar.defaultProps = {
  isVisible: false,
  onBackdropClick: () => {},
  onLogout: () => {},
  onChangePassword: () => {},
  onNavigate: () => {},
  roles: [],
  onIntegrationTokenRequest: () => {},
};

function mapStateToProps(state) {
  return {
    ui: getPlatformUsersUI(state),
  };
}

export default connect(mapStateToProps)(Sidebar);
